// extracted by mini-css-extract-plugin
module.exports = {"container":"Partnerships_container__KnbFY","heading":"Partnerships_heading__aYF2l","copy":"Partnerships_copy__fHyDD","cta":"Partnerships_cta__LNQ2m"};